import { render, staticRenderFns } from "./UpgradeButton.vue?vue&type=template&id=22f229c6&"
import script from "./UpgradeButton.vue?vue&type=script&lang=ts&"
export * from "./UpgradeButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports